// extracted by mini-css-extract-plugin
export var deleteIcon = "_r0-5";
export var deleteOption = "_r0-3";
export var divider = "_r0-2";
export var downloadIcon = "_r0-4";
export var drawer = "_r0-0";
export var drawerFooter = "_r0-6";
export var drawerOpen = "_r0-1";
export var highlighted = "_r0-7";
export var lighterHighlight = "_r0-8";